<template>
  <QuestionnaireBase :form="form" :title="title" :finishFunction="null">
    <template v-slot:default>
      <component :is="show" :key="1" :ref="show" v-model="form"/>
      <component
          v-if="load in $options.components"
          v-show="false"
          :is="load"
          key="load"
          :ref="load"
          v-model="form"
      />
    </template>
  </QuestionnaireBase>
</template>

<script>
import {loadHelpers} from "../../loadHelpers";
import {dateFormat} from "@/mixins/dateFormat";

import QuestionnaireBase from "../../../../components/common/questionnaires/questionnaire";
import ExistingProductsLpa
  from "@/components/common/questionnaires/fieldsets/estatePlanningSurvey/simple/ExistingProductsLpa";
import ExistingProductsWill
  from "@/components/common/questionnaires/fieldsets/estatePlanningSurvey/simple/ExistingProductsWill";

export default {
  name: "EstatePlanningSurveySimpleExistingProducts",
  mixins: [loadHelpers, dateFormat],
  components: {
    QuestionnaireBase,
    ExistingProductsLpa,
    ExistingProductsWill
  },
  data() {
    return {
      name: 'EstatePlanningSurvey',
      title: 'Estate Planning Survey',
      url: 'estate_planning_survey',
      order:
          [
            'ExistingProductsWill',
            'ExistingProductsLpa'
          ],
      expiryAccessCodeOnFinish: true

    }
  }
};
</script>
